import React from 'react';
import styled, { css } from 'styled-components';
import SpinKit from 'react-spinkit';

type SpinnerPropType = {
  name: 'line-scale' | 'cube-grid' | 'three-bounce',
  fadeIn?: 'none' | 'quarter' | 'half' | 'full',
  bsSize: 'lg' | 'sm',
  inline: boolean,
  className: ?string,
  color?: string,
  hidden: boolean,
  bsColor?: string,
  inFlexContainer?: boolean,
  message: string,
};

const initialValues = {
  name: 'line-scale',
  fadeIn: 'none',
  inline: false,
  hidden: false,
  bsSize: 'lg',
  message: '',
};

const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledSpinKit = styled((props) => (
  <SpinKit
    className={props.className}
    color={props.color}
    fadeIn={props.fadeIn}
    name={props.name}
  />
))`
  ${(props) => css`
    && {
      height: ${props.size};
      display: ${props.inline ? 'inline-block' : 'block'};
      visibility: ${props.hidden ? 'hidden' : 'visible'};
      margin-left: ${props.inline ? '.5rem' : 'unset'};
      margin-right: ${props.inline ? '.5rem' : 'unset'};
    }

    &&.sk-three-bounce > div {
      height: ${props.size};
      width: ${props.size};
    }

    &.line-scale > div {
      height: ${props.bsSize === 'sm' ? '.7rem' : '1.2rem'} !important;
      width: ${props.bsSize === 'sm' ? '.2rem' : '.333rem'};
      margin: ${props.bsSize === 'sm' ? '.1rem' : '.166rem'};
      border-radius: ${props.bsSize === 'sm' ? '.066rem' : '.088rem'};
    }

    &&.sk-cube-grid {
      width: ${props.size};
    }
  `}
`;

const StyledSpinKitWrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledSpinnerMessage = styled.span`
  position: absolute;
  top: 100%;
  white-space: nowrap;
`;

export const Spinner = (props: SpinnerPropType) => {
  const size = props.bsSize === 'sm' ? '1rem' : '1.5rem';

  const spinnerElement = (
    <StyledSpinKitWrapper>
      <StyledSpinKit size={size} {...props} />
      <StyledSpinnerMessage>{props.message}</StyledSpinnerMessage>
    </StyledSpinKitWrapper>
  );

  if (props.inFlexContainer) {
    return (
      <StyledFlexContainer className={props.className || null}>
        {spinnerElement}
      </StyledFlexContainer>
    );
  } else {
    return spinnerElement;
  }
};


Spinner.defaultProps = initialValues;

export default Spinner;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Spinner.js